import {t} from 'i18next';
import {
  getInboxPendingCount,
  useExecSponsorInboxWorkstreams,
} from 'views/workstreams/inbox/useExecSponsorInbox';

import {RailPlaceRow} from './RailPlaceRow';

/**
 * /workstreams: the rail's Exec inbox row (behind `?exec=1`), for
 * exec sponsors. Its count is unread review items plus needs-resolution items
 * across the workstreams you sponsor.
 */
export const InboxRailRow = ({
  selected,
  onSelect,
  bleed,
  touch = false,
}: {
  selected: boolean;
  onSelect: () => void;
  bleed: {left: number; right: number};
  touch?: boolean;
}) => {
  const {data} = useExecSponsorInboxWorkstreams();
  const workstreams = data?.workstreams ?? [];

  if (workstreams.length === 0) return null;

  const count = workstreams.reduce((sum, workstream) => sum + getInboxPendingCount(workstream), 0);
  return (
    <RailPlaceRow
      label="Exec inbox"
      count={count}
      countLabel={t('workstream_exec_sponsor_inbox_unread_count', {count}).toString()}
      selected={selected}
      onSelect={onSelect}
      bleed={bleed}
      touch={touch}
    />
  );
};
